import axios from './custom_axios';
import Cookies from 'js-cookie';
const API_URL = process.env.REACT_APP_API_URL;

const getOrderDetailsByUser = async () => {
    const token = Cookies.get("Token");
    if (!token) {
        return;
    }

    try {
        const response = await axios.get(`${API_URL}/api/v1/cshp-order-details`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        return { message: 'fail' };
    }
}
export { getOrderDetailsByUser };